import { API_ROOT } from '../config';

// Acepta las dos formas que devuelve el backend:
//   ruta relativa  -> '/uploads/products/x.jpg'  (almacenamiento local)
//   URL absoluta   -> 'https://bucket.s3...'     (almacenamiento S3)
export const imgUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return `${API_ROOT}${path.startsWith('/') ? '' : '/'}${path}`;
};
